module.exports = __webpack_public_path__ + "static/media/logo-black.2e926640.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo-black.png
// module id = 1053
// module chunks = 0